export function ParentContactDetails({ email, phone }: { email?: string | null; phone?: string | null }) {
  const address = email?.trim();
  const number = phone?.trim();
  const dialable = number?.replace(/[^\d+]/g, "");
  const emailSeparator = address?.lastIndexOf("@") ?? -1;
  const mailto = address && emailSeparator > 0
    ? `mailto:${encodeURIComponent(address.slice(0, emailSeparator))}@${encodeURIComponent(address.slice(emailSeparator + 1))}` : null;
  return <dl className="student-record-parent-contact" aria-label="Parent contact details">
    <div><dt>Parent email</dt><dd>{address
      ? mailto ? <a href={mailto}>{address}</a> : address : email === undefined ? "Unavailable" : "Not recorded"}</dd></div>
    <div><dt>Parent phone</dt><dd>{number
      ? dialable && /\d/.test(dialable) ? <a href={`tel:${dialable}`}>{number}</a> : number : phone === undefined ? "Unavailable" : "Not recorded"}</dd></div>
  </dl>;
}
